export default __webpack_public_path__ + "static/media/LarissaAndrade.a440baf1.png";